import { useIntl } from 'react-intl';
import { DrawerCard } from './DrawerCard';
import { EuiIcon, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { Button } from '../Button';

import './styles.scss';
import { useQuery } from '@apollo/client';
import { Query, QueryGetAvailableRegionsArgs } from 'generated/graphql';
import { Icon } from 'icon/Icon';
import { REGIONS } from 'apollo-client';
import { country } from 'cache';

export const ChangePassword = (): JSX.Element => {
  return (
    <DrawerCard title="Change password">
      <p className="change-password">
        Per effettuare un cambio password scrivere all’inidirizzo{' '}
        <a href="mailto:tech@salesspeed.ai">tech@salesspeed.ai</a>
      </p>
    </DrawerCard>
  );
};

interface PreferencesProps {
  regions?: EuiComboBoxOptionOption<string>[];
  onChangeRegions: (e: EuiComboBoxOptionOption<string>[]) => void;
  onSave: () => void;
  isLoading: boolean;
}

export const Preferences = ({ regions, onChangeRegions, onSave, isLoading }: PreferencesProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const { data } = useQuery<Query, QueryGetAvailableRegionsArgs>(REGIONS, {
    fetchPolicy: 'network-only',
    variables: { inputRegion: '', inputCountry: country() },
  });

  return (
    <DrawerCard title="Preferenze">
      <div className="preferences">
        <p>{formatMessage({ id: 'filters.regions.label' })}</p>
        <div className="preferencesRegionsInput">
          <EuiComboBox
            placeholder={formatMessage({ id: 'filters.regions.placeholder' })}
            options={data?.getAvailableRegions?.map((x) => ({ label: x, value: x }))}
            selectedOptions={regions}
            onChange={onChangeRegions}
          />
        </div>
        <Button isLoading={isLoading} onClick={onSave}>
          Salva
        </Button>
      </div>
    </DrawerCard>
  );
};

export const Logout = ({ onClick }: { onClick: () => void }): JSX.Element => (
  <DrawerCard title="Logout">
    <div className="logout" onClick={onClick}>
      <EuiIcon type="exit" />
      <p>Logout</p>
    </div>
  </DrawerCard>
);

export const Icons = (): JSX.Element => (
  <DrawerCard title="Icone">
    <ul className="icons">
      <li className="item">
        <div className="icon">
          <Icon iconName="Warranty" />
        </div>
        Veicolo provvisto di Garanzia ufficiale
      </li>
      <li className="item">
        <div className="icon">
          <Icon iconName="Lock" />
        </div>
        Prezzo vincolato a finanziamento
      </li>
      <li className="item">
        <div className="icon">
          <Icon iconName="NewAds" />
        </div>
        Pubblicazione di nuovi annunci dello stesso allestimento rispetto al giorno precedente
      </li>
      <li className="item">
        <div className="icon">
          <Icon iconName="PriceUp" />
        </div>
        Aumento del prezzo consigliato rispetto al giorno precedente
      </li>
      <li className="item">
        <div className="icon">
          <Icon iconName="PriceDown" />
        </div>
        Diminuzione del prezzo consigliato rispetto al giorno precedente
      </li>
    </ul>
  </DrawerCard>
);
